import React, { lazy } from "react";

export const TEAM_MANAGEMENT_BASE_PATH = 'teams/management';

export class RouteConstants {
  static Form = lazy(
    () =>
      import(
        /* webpackChunkName: "team-management" */ "./../layout/TeamManagement"
      )
  );

  // Define module routes for the patients module
  static readonly MODULE_ROUTES = [
    {
      path: `${TEAM_MANAGEMENT_BASE_PATH}/add`, // URL path for the patients list
      component: React.createElement(RouteConstants.Form, { type: "Add" }), // Component to render for this route
      actionName: "add", // Action name associated with this route
      displayName: "Teams Add", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
    {
      path: `${TEAM_MANAGEMENT_BASE_PATH}/:id/details`, // URL path for the patients list
      component: React.createElement(RouteConstants.Form, { type: "View" }), // Component to render for this route
      actionName: "view", // Action name associated with this route
      displayName: "Teams View", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
    {
      path: `${TEAM_MANAGEMENT_BASE_PATH}/:id/edit`, // URL path for the patients list
      component: React.createElement(RouteConstants.Form, { type: "Edit" }), // Component to render for this route
      actionName: "edit", // Action name associated with this route
      displayName: "Teams Edit", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
  ];
}
